import { useEffect, useState, useRef } from "react";
import { Onfido } from "onfido-sdk-ui";
import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL; // 'http://localhost:8000';

const OnfidoVerification = () => {
  const [isStarted, setIsStarted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [applicationId, setApplicationId] = useState(null);
  const [applicantId, setApplicantId] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const onfidoInstance = useRef(null);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setApplicationId(params.get("applicationId"));
    setApplicantId(params?.get('applicantId'));

    // console.log("Application Id from Native Project", applicationId)
    // console.log("GAM Applicant Id from Native Project", applicantId);

    const handleMessage = (event) => {
      const data = event.data;
      const parsed =
        typeof data === "string" ? JSON.parse(data) : data;

      if (parsed.type === "INIT_ONFIDO") {
        // console.log("Token received from parent:", parsed.accessToken);
        setAccessToken(parsed.accessToken);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const tearDownOnfido = () => {
    if (onfidoInstance.current) {
      onfidoInstance.current.tearDown();
      onfidoInstance.current = null;
    }
  };

  const initOnfido = (token, workflowId) => {
    setIsStarted(true);
    setError(null);
    tearDownOnfido();

    setTimeout(() => {
      try {
        onfidoInstance.current = Onfido.init({
          token: token,
          workflowRunId: workflowId,
          containerId: "onfido-mount",
          forceCrossDevice: true,
          onComplete: function (data) {
            console.log("Flow complete:", data)
            window.parent.postMessage('onfido_finished', '*');
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage('onfido_finished');
            }
          },
          onError: (error) => {
            console.error("Onfido Error:", error);
            setError("The verification session failed to initialize. Please try again.");
            setIsStarted(false);
          },
        });
      } catch (e) {
        setError("Critical error loading the SDK.", e)
        setIsStarted(false);
      }
    }, 50);
  };

  const url = `${apiUrl}/application/onfido-users`;
  const startSDK = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log(
        "Authorization Header",
        `Bearer ${accessToken}`
      );
      console.log({
        applicationId,
        applicantId,
        accessToken
      });
      const response = await axios.post(
        url,
        {},
        {
          params: {
            applicationId: applicationId,
            gamApplicantId: applicantId
          },
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { sdkToken, workflowRunId } = response.data;
      console.log("Received SDK Token and Workflow ID:", { sdkToken, workflowRunId });
      window.parent.postMessage(
        JSON.stringify({
          type: "ONFIDO_WORKFLOW_RUN_ID",
          workflowRunId,
        }),
        "*"
      );

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "ONFIDO_WORKFLOW_RUN_ID",
            workflowRunId,
          })
        );
      }
      initOnfido(sdkToken, workflowRunId);
    } catch (error) {
      // console.log("API Error, falling back:", error.message);
      setError(error.response?.data?.message || "Failed to start verification.")
    } finally {
      setLoading(false);
    }
  };

  const handleRestart = () => {
    tearDownOnfido();
    setIsStarted(false);
    setError(null);
  };

  useEffect(() => {
    return () => tearDownOnfido();
  }, []);

  return (
    <div style={styles.pageCenter}>
      {error && !isStarted && (
        <div style={{ ...styles.card, borderColor: "#ff4d4f", border: "1px solid #ff4d4f" }}>
          <h2 style={{ ...styles.title, color: "#ff4d4f" }}>Verification Error</h2>
          <p style={styles.text}>{error}</p>
          <button onClick={handleRestart} style={styles.button} disabled={loading}>
            {loading ? "Retrying..." : "Try Again"}
          </button>
        </div>

      )}

      {!isStarted && !error && (accessToken &&
        <div style={styles.card}>
          <h2 style={styles.title}>Identity Verification</h2>

          <p style={styles.text}>
            To complete your identity verification, you will be required to upload
            <strong> 2 identity documents</strong>.
          </p>

          <div style={styles.infoBox}>
            <p style={styles.infoTitle}>Supported Country</p>

            <ul style={styles.list}>
              <li>Trinidad & Tobago</li>
            </ul>
            <p style={styles.infoTitle}>Supported Documents</p>

            <ul style={styles.list}>
              <li>National Identification Card</li>
              <li>Driver’s License</li>
              <li>Passport</li>
            </ul>
          </div>

          <p style={styles.subText}>
            Please ensure your documents are valid, clear, and fully visible before
            starting the verification process.
          </p>

          <button onClick={startSDK} style={styles.button} disabled={loading}>
            {loading ? "Loading..." : "Start Verification"}
          </button>
        </div>
      )}

      {isStarted && (
        <div style={styles.activeWrapper}>
          <div id="onfido-mount" style={styles.onfidoContainer} />
          <button onClick={handleRestart} style={styles.restartButton}>
            ✕ Cancel & Restart
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  pageCenter: {
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    // backgroundColor: "#f5f7fa",
    marginTop: 0,
    padding: 0,
    overflow: "hidden",
    position: "relative",
  },
  card: {
    textAlign: "center",
    padding: "40px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    maxWidth: "400px",
    width: "90%",
  },
  activeWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  onfidoContainer: {
    width: "100%",
    maxWidth: "500px",
    height: "calc(100% - 80px)",
    maxHeight: "700px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  restartButton: {
    margin: "10px 0",
    backgroundColor: "transparent",
    color: "#ff4d4f",
    border: "1px solid #ff4d4f",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    zIndex: 10,
    marginTop: '20px'
  },
  button: {
    backgroundColor: "#353ffc",
    color: "#fff",
    border: "none",
    padding: "12px 24px",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  title: { marginBottom: "10px", color: "#131b26" },
  text: { marginBottom: "20px", color: "#6b7785" },
  infoBox: {
    backgroundColor: "#f5f7ff",
    border: "1px solid #dbe4ff",
    borderRadius: "8px",
    padding: "14px",
    marginBottom: "20px",
    textAlign: "left",
  },

  infoTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#131b26",
    marginBottom: "10px",
  },

  list: {
    margin: 0,
    paddingLeft: "20px",
    color: "#4b5563",
    lineHeight: 1.8,
  },

  subText: {
    marginBottom: "20px",
    color: "#6b7785",
    fontSize: "14px",
  },
};

export default OnfidoVerification;

// import { useEffect, useState, useRef } from "react";
// import { Onfido } from "onfido-sdk-ui";

// const OnfidoVerification = () => {
//   const [isStarted, setIsStarted] = useState(false);
//   const onfidoInstance = useRef(null);

//   const startSDK = () => {
//     setIsStarted(true);

//     // Safety check: tear down existing instance if it somehow exists
//     if (onfidoInstance.current) {
//       onfidoInstance.current.tearDown();
//     }

//     onfidoInstance.current = Onfido.init({
//       token:
//         "eyJhbGciOiAiRVM1MTIifQ.eyJpc3MiOiAic3R1ZGlvIiwgImF1ZCI6ICJmNzllOWJjYi03NTE5LTQ4N2UtOTkwOC1jZDExM2M3NjZlMjQiLCAic3ViIjogIjRlNzdhZjQ4LWU4NzYtNDY5ZS04YWNkLTg1ZDJhMDBmYTEwYyIsICJpYXQiOiAxNzcwODM3OTA0LCAianRpIjogInN0dWRpby00ZTc3YWY0OC1lODc2LTQ2OWUtOGFjZC04NWQyYTAwZmExMGMiLCAiZXhwIjogMTc3Mzg2MTkwNCwgInBheWxvYWQiOiB7ImFwcCI6ICIzOWE5YTNjNi03NTNjLTQ4NjctYTI5Zi1mODY5NzVhM2U4YWIiLCAiYXBwbGljYXRpb25faWQiOiAiKiIsICJjbGllbnRfdXVpZCI6ICJmNzllOWJjYi03NTE5LTQ4N2UtOTkwOC1jZDExM2M3NjZlMjQiLCAiaXNfc2FuZGJveCI6IGZhbHNlLCAiaXNfc2VsZl9zZXJ2aWNlX3RyaWFsIjogZmFsc2UsICJpc190cmlhbCI6IGZhbHNlLCAic2FyZGluZV9zZXNzaW9uIjogIjEzYjM4ZDY0LTU2MzMtNDEwNi1iZmNiLWJhMzgxOTJlYmQ5YSIsICJjdXN0b21lcl91c2VyX2hhc2giOiAiOE9yc0VRM3dOSkduYmJKeFR5YWphdmNOVEdvVHhIb2hnam1vQ1dEOGxhWT0ifSwgInVybHMiOiB7InN5bmNfdXJsIjogImh0dHBzOi8vc3luYy5vbmZpZG8uY29tIiwgImhvc3RlZF9zZGtfdXJsIjogImh0dHBzOi8vaWQub25maWRvLmNvbSIsICJhdXRoX3VybCI6ICJodHRwczovL2FwaS51cy5vbmZpZG8uY29tIiwgIm9uZmlkb19hcGlfdXJsIjogImh0dHBzOi8vYXBpLnVzLm9uZmlkby5jb20iLCAidGVsZXBob255X3VybCI6ICJodHRwczovL2FwaS51cy5vbmZpZG8uY29tIn0sICJlbnRlcnByaXNlX2ZlYXR1cmVzIjogeyJ2YWxpZENyb3NzRGV2aWNlVXJscyI6IFtdfX0.MIGIAkIA-qsRSZatAGwzIMa2P8kw-em9PldpO0v2q_eEkUROEGg6QDonrrnsvlXzk-76LGMGK9FtgwJ05vZD_fSCH1D2Vd4CQgFUylpzTqjRTKPlz3IRc5piKlKWppmH2cQrwu-FcDaJ-0LBJjrRCIrQV_W56LHgT2g_C1FAtXhYvA8gED1FbTRRwg",
//       workflowRunId: "4e77af48-e876-469e-8acd-85d2a00fa10c",
//       containerId: "onfido-mount",
//       onComplete: (data) => {
//         console.log("Flow complete:", data);
//       },
//     });
//   };

//   useEffect(() => {
//     // Cleanup function to prevent double-rendering
//     return () => {
//       if (onfidoInstance.current) {
//         onfidoInstance.current.tearDown();
//         onfidoInstance.current = null;
//       }
//     };
//   }, []);

//   return (
//     <div style={styles.pageCenter}>
//       {!isStarted ? (
//         <div style={styles.card}>
//           <h2 style={styles.title}>Identity Verification</h2>
//           <p style={styles.text}>
//             Click the button below to start your secure ID check.
//           </p>
//           <button onClick={startSDK} style={styles.button}>
//             Start Verification
//           </button>
//         </div>
//       ) : (
//         <div id="onfido-mount" style={styles.onfidoContainer}></div>
//       )}
//     </div>
//   );
// };

// const styles = {
//   pageCenter: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     minHeight: "100vh",
//     width: "100vw",
//     backgroundColor: "#f5f7fa",
//   },
//   card: {
//     textAlign: "center",
//     padding: "40px",
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//     maxWidth: "400px",
//     width: "100%",
//   },
//   title: {
//     marginBottom: "10px",
//     color: "#131b26",
//   },
//   text: {
//     marginBottom: "20px",
//     color: "#6b7785",
//   },
//   button: {
//     backgroundColor: "#353ffc",
//     color: "#fff",
//     border: "none",
//     padding: "12px 24px",
//     borderRadius: "6px",
//     fontSize: "16px",
//     fontWeight: "bold",
//     cursor: "pointer",
//     transition: "background 0.2s",
//   },
//   onfidoContainer: {
//     width: "100%",
//     maxWidth: "500px",
//     minHeight: "600px",
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     overflow: "hidden",
//   },
// };

// export default OnfidoVerification;
